module.exports = __webpack_public_path__ + "media/parents/fafsa-is-available-2e9b515d.png";